import styled from 'styled-components';
import { TYPOGRAPHY, COLOR } from './../../theme/constants';

export const Subscribe = styled.div`
   position: relative;
   border: 1px solid #e5e5e5;
   padding: 20px;
   width: 709px;
   min-height: 216px;
   height: auto;
   display: flex;
   flex-direction: column;
   background-color: inherit;
   font-size: 14 px;
`;

export const SubscribeBackground = styled.div`
   background-color: #111;
   position: absolute;
   left: 0;
   right: 0;
   top: 0;
   bottom: 0;
   display: flex;
   justify-content: flex-end;
`;

export const SubscribeSignup = styled.div`
   display: block;
   z-index: 2;
   padding-left: 9px;

   &.swap {
      display: none;
   }
`;

export const SubscribeTitle = styled.p`
   margin: 0px;
   font-size: 30px;
   color: white;
   ${TYPOGRAPHY.BOLD}
`;

export const SubscribeBodyText = styled.p`
   font-size: 18px;
   color: ${COLOR.LIGHTGREY};
   margin-top: 5px;
`;

export const SubscribeEmailField = styled.input`
   margin-bottom: 5px;
   text-rendering: optimizeLegibility;
   -webkit-font-smoothing: antialiased;
   -moz-osx-font-smoothing: grayscale;
   font-style: normal;
   font-size: 13px;
   width: 348px;
   border: none;
   border-radius: 30px;
   box-shadow: inset 0 0 10px 0 rgba(0, 0, 0, 0.05);
   background-color: ${COLOR.LIGHTGREY};
   padding: 0 15px;
   height: 44px;
   outline: none;
`;

export const SubscribeSubmitButton = styled.input`
   border-radius: 25px;
   width: 118px;
   cursor: pointer;
   background-color: #007eff;
   font-size: 14px;
   margin-bottom: 5px;
   margin-left: 15px;
   height: 44px;
   ${TYPOGRAPHY.BOLD}
   font-style: normal;
   color: white;
   border: none;
   outline: none;
`;

export const SubscribeCaliforniaResidentContainer = styled.div`
   display: flex;
   color: #777;
   font-size: 12px;
   width: 150px;
   float: left;
`;

export const AcceptTermsCheck = styled.input`
   margin-right: 10px;
   margin-top: 3px;
`;

export const SubscribeAcceptTermsContainer = styled.div`
   display: flex;
   color: #777;
   font-size: 12px;
   width: 300px;
   left: 180px;

   &.error {
      color: red;
   }
`;

export const SubscribeValidation = styled.div`
   color: #e91019;
   font-size: 12px;
   font-weight: bold;
   margin-top: -16px;
`;

export const SubscribeThankyou = styled.div`
   z-index: 2;
   display: none;
   margin: auto;
   align-self: center;
   &.swap {
      display: block;
   }
`;

export const SubscribeThankyouText = styled.p`
   font-size: 18px;
   color: ${COLOR.LIGHTGREY};
   line-height: 0px;
`;

export const SubscribeToDailyNewsletter = styled.div`
   background-color: black;
`;

export const ArticlesLink = styled.a`
   font-size: 18px;
   color: #007eff;
`;

export const StyledDisclaimer = styled.div`
   font-size: 0.7rem;
   max-width: 530px;
   color: ${COLOR.LIGHTGREY4};
   margin: 5px 0 0 5px;
   a {
      color: ${COLOR.BLUE};
   }
`;

export const CheckWrapper = styled.div`
   margin-top: 8px;
`;
